import React from 'react';
import { I18nContext } from "../../i18n/useI18n";

// Enum para todos os membros da equipe
enum TeamMembers {
  LUCAS = 'lucas',
  ANA_PAULA = 'ana_paula',
  CLARISSA = 'clarissa',
  CLAUDIO_MASUDA = 'claudio_masuda',
  MONICA = 'monica',
  HELENA = 'helena',
  JOICE = 'joice',
  JULIANO = 'juliano',
  MARIANA = 'mariana',
  VITORIA = 'vitoria',
  PAULA_YAMAMOTO = 'paula_yamamoto',
  CAIO_VITOR_GOULART = 'caio_vitor_goulart',
  ANDRE_GOULART = 'andre_goulart',
  GIOVANNI = 'giovanni'
}

// Definindo o tipo de TeamMember para as props
type TeamMemberProps = {
  name: string;
  position: string;
  tasksTitle: string;
  tasks?: string;
};

// Componente individual para cada membro da equipe
const TeamMemberCard: React.FC<TeamMemberProps> = ({ name, position, tasksTitle, tasks }) => (
  <div className="ui-card-element-base ui-card-element-background ui-dynamic-flex p-4 shadow-md rounded-md">
    <div className="ui-content-box-padding ui-content-box-body">
      <div className="ui-content-box__text ui-h-full">
        
        <p className="font-semibold text-lg">{name}</p>
        <p className="font-medium uppercase tracking-widest text-[14px]">{position}</p>
        <div>
          {/* <p className="font-semibold pt-4 pb-0.5">{tasksTitle}</p> */}
          <p className="text-[14px]">{!tasks?"":tasks}</p>
        </div>
      </div>
    </div>
  </div>
);

// Componente principal para exibir todos os membros da equipe
const TeamLine: React.FC = () => {
  const { t } = React.useContext(I18nContext);

  // Pega todas as chaves do enum TeamMembers
  const teamKeys = Object.values(TeamMembers);

  return (
    <div className="grid md:grid-cols-2 gap-4 py-8">
      {teamKeys.map((key) => {
        // Usando o 'key' do enum para acessar as propriedades dinamicamente com 't'
        const name = t(`pages.team.team.${key}.name`);
        const position = t(`pages.team.team.${key}.position`);
        const text = t(`pages.team.team.${key}.text`);
        const tasksTitle = t('team.tasks');// Verificação se os valores existem para evitar erro de null ou undefined
        if (!name || !position || !text) return null;

        return (
          <TeamMemberCard
            key={key}
            name={name}
            position={position}
            tasksTitle={tasksTitle}
            tasks={text}
          />
        );
      })}
    </div>
  );
};

export default TeamLine;
